import type { Product } from "./product-types";
import { normalizeBrandText } from "./brandDirectory.ts";

export type RecommendationSections = {
  selectedBrand: Product[];
  alternatives: Product[];
};

export function hasSelectedBrand(brand: string): boolean {
  return Boolean(brand && !brand.includes("不限"));
}

export function partitionRecommendations(products: Product[], brand: string): RecommendationSections {
  if (!hasSelectedBrand(brand)) return { selectedBrand: products, alternatives: [] };
  const selectedKey = normalizeBrandText(brand);
  return products.reduce<RecommendationSections>((sections, product) => {
    const keys = [product.brand, product.brandNameEn, product.brandNameCn].map(normalizeBrandText).filter(Boolean);
    (keys.includes(selectedKey) ? sections.selectedBrand : sections.alternatives).push(product);
    return sections;
  }, { selectedBrand: [], alternatives: [] });
}
